import common from 'assets/themes/vacances-campings/js/page/common/index'

export default function (): void {
  const preventOpenClasses = ['toggle-map-link', 'localisation', 'review__link', 'review__title', 'review__value', 'review__max']

  document.querySelectorAll('.result__best-offer').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement, e) {
      const target = e.target as HTMLElement

      if (preventOpenClasses.filter((val) => target.classList.contains(val)).length === 0) {
        e.preventDefault()
        e.stopPropagation()

        const button = this.querySelector<HTMLLinkElement>('.dca-button')
        let link: string | null | undefined

        if (button) {
          link = button.getAttribute('data-href') || button.href
          // The link can be obfuscated (see assets/core/js/module/seo-link.ts).
          if (button.getAttribute('data-seo-link-href')) {
            link = atob(button.getAttribute('data-seo-link-href') as string)
          }
        } else {
          link = getProductPageUrl(this.closest('.result'))
        }
        openLink(link, target)
      }
    })
  })

  document.querySelectorAll('.results__list .result__details').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement, e) {
      const target = e.target as HTMLElement

      if (!common.isMobile() && preventOpenClasses.filter((val) => target.classList.contains(val)).length === 0) {
        e.preventDefault()
        e.stopPropagation()

        const link = getProductPageUrl(this)
        openLink(link, target)
      }
    })
  })

  document.querySelectorAll('.results__list .result__image img').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement, e) {
      const target = e.target as HTMLElement

      e.preventDefault()
      e.stopPropagation()

      const link = getProductPageUrl(this.closest('.result'))
      openLink(link, target)
    })
  })

  document.querySelectorAll('.product__reviews').forEach(function (el) {
    el.addEventListener('click', function (this: HTMLElement, e) {
      const target = e.target as HTMLElement

      if (preventOpenClasses.filter((val) => target.classList.contains(val)).length === 0) {
        e.preventDefault()
        e.stopPropagation()

        const link = this.querySelector<HTMLLinkElement>('.review__link')
        let href = null
        if (!common.isMobile() && link) {
          href = link.href
        } else if (link) {
          href = link.href.split('#')[0]
        }
        openLink(href, target)
      }
    })
  })
}

function getProductPageUrl(el: Element | null): string | null {
  return el?.querySelector<HTMLLinkElement>('a.product__name, .result__name a')?.href ?? null
}

function openLink(url: string | null | undefined, el: HTMLElement): void {
  if (url) {
    if (!common.isMobile()) {
      window.open(url)
    } else {
      document.location.href = url
    }

    const event = new CustomEvent('productPageLink.opened', {
      detail: { productId: el.closest('.result')?.getAttribute('data-id') },
    })
    window.dispatchEvent(event)
  }
}
